import { i18n } from '@shared/i18n';
import _values from 'lodash/values';

export default class SubprogramDays {
  static get values() {
    return {
      monday: 'monday',
      tuesday: 'tuesday',
      wednesday: 'wednesday',
      thursday: 'thursday',
      friday: 'friday',
      saturday: 'saturday',
      sunday: 'sunday',
    };
  }

  static labelOf(SubprogramDayId) {
    if (!this.values[SubprogramDayId]) {
      return SubprogramDayId;
    }

    return i18n(`entities.subprogram.days.${SubprogramDayId}.label`);
  }

  static descriptionOf(SubprogramDayId) {
    if (!this.values[SubprogramDayId]) {
      return SubprogramDayId;
    }

    return i18n(`entities.subprogram.days.${SubprogramDayId}.description`);
  }

  static get selectOptions() {
    return _values(this.values).map((value) => ({
      id: value,
      value: value,
      title: this.descriptionOf(value),
      label: this.labelOf(value),
    }));
  }
}
